//import $ from 'jquery';

const
  NAME               = 'shareSelection',
  VERSION            = '1.0.0',
  JQUERY_NO_CONFLICT = $.fn[NAME],

  TEMPLATE_HEIGHT     = 90,
  DISTANCE_ABOVE      = 115,
  NEW_WINDOW_TOP      = 125,
  NEW_WINDOW_WIDTH    = 500,
  NEW_WINDOW_LEFT     = _calcLeftPosition(),
  NEW_WINDOW_HEIGHT   = 350,
  NEW_WINDOW_TOOLBAR  = 0,
  NEW_WINDOW_MENUBAR  = 0,
  NEW_WINDOW_TITLEBAR = 0,
  NEW_WINDOW_STATUS   = 0,
  OPEN_LINK_TYPE      = 'popup',
  OPEN_LINK_OPTS      = `top=${NEW_WINDOW_TOP}, width=${NEW_WINDOW_WIDTH}, left=${NEW_WINDOW_LEFT}, height=${NEW_WINDOW_HEIGHT}, toolbar=${NEW_WINDOW_TOOLBAR}, menubar=${NEW_WINDOW_MENUBAR}, titlebar=${NEW_WINDOW_TITLEBAR}, status=${NEW_WINDOW_STATUS}`,
  FACEBOOK            = 'facebook',
  FACEBOOK_CLASS      = 'voc-facebook-share',
  TWITTER             = 'twitter',
  TWITTER_CLASS       = 'voc-twitter-share',
  TEMPLATE            = `
    <div class="voc-select-tooltip">
      <a title="${FACEBOOK}" class="${FACEBOOK_CLASS}"><i class="voc-icons facebook"></i></a>
      <a title="${TWITTER}" class="${TWITTER_CLASS}"><i class="voc-icons twitter"></i></a>
    </div>
  `
;

var _selector$, _lastText;

class ShareSelection {
  constructor(element$, {offset_top}) {
    element$.on('mouseup', 'p', this.onMouseUp.bind(this));
    this.headerHeight = offset_top;
  }

  onMouseUp(event) {
    this.selection = this.getSelected();
    this.text      = this.selection.toString().trim();
    this.mouseX    = event.pageX;
    this.mouseY    = event.pageY;
    this.window$   = $(window);

    if (this.text && this.text !== _lastText) {
      _lastText = this.text;
      this.showSelector();
    } else if (_selector$) {
      _selector$.hide();
    }
  }

  showSelector() {
    if (!_selector$) {this.renderSelector();}

    this.setShareUrl(this.text);

    if ((this.window$.scrollTop() + this.headerHeight + TEMPLATE_HEIGHT) > this.mouseY) {
      this.mouseY = this.mouseY + DISTANCE_ABOVE;
      _selector$.addClass('voc-above');
    } else {
      _selector$.removeClass('voc-above');
    }

    _selector$
      .css('top', this.mouseY)
      .css('left', this.mouseX)
      .show()
    ;
  }

  renderSelector() {
    _selector$ = $(TEMPLATE);
    $('body').append(_selector$);
  }

  setShareUrl(text) {
    var multiEdition = this.checkMultiedition();

    _selector$.find(`.${FACEBOOK_CLASS}`).on('click', () => {
      window.open(`//www.facebook.com/sharer.php?u=${encodeURIComponent(window.location.href)}${multiEdition}&quote=${encodeURIComponent(text)}`, OPEN_LINK_TYPE, OPEN_LINK_OPTS);
    });
    _selector$.find(`.${TWITTER_CLASS}`).on('click', () => {
      let twitterUser  = this.checkTwitterUser();
      window.open(`//twitter.com/share?url=${encodeURIComponent(window.location.href)}${multiEdition}&text=${encodeURIComponent(text)}${twitterUser}`, OPEN_LINK_TYPE, OPEN_LINK_OPTS);
    });
  }

  checkMultiedition() {
    var editions = Voonto.getInstance().lookup('vocento.site.editions');
    return editions.hasEditions ? `?${editions.queryString}=${editions.current}` : '';
  }

  checkTwitterUser() {
    var username = document.querySelector('meta[name="twitter:site"]');
    return username && username.content ? `&via=${username.content.slice(1)}` : '';
  }

  getSelected() {
    var selection;

    if (window.getSelection) {
      selection = window.getSelection();
    } else if (document.getSelection) {
      selection = document.getSelection();
    } else if (document.selection) {
      selection = document.selection.createRange().text;
    }

    return selection;
  }


  static get VERSION() {
    return VERSION;
  }

  static _jQueryInterface(options) {
    return this.each(function() {
      new ShareSelection($(this), options);
    });
  }
}

$.fn[NAME]             = ShareSelection._jQueryInterface;
$.fn[NAME].Constructor = ShareSelection;
$.fn[NAME].noConflict  = function noConflict() {
  $.fn[NAME] = JQUERY_NO_CONFLICT;
  return ShareSelection._jQueryInterface;
};

export default ShareSelection;

/* Private */

function _calcLeftPosition() {return ((screen.width / 2) - (NEW_WINDOW_WIDTH / 2));}



// WEBPACK FOOTER //
// ./src/plugins/share-selection.js